<div class="navbar">
  <img src="./assets/temporals/Logo_Akana_Azul.png" alt="">
  <ul class="first-ul">
    <li>
      Eurobits
      <ul class="first">
        <li (click)="goToURL('auto')">Automática</li>
        <li (click)="goToURL('manual')">Manual</li>
      </ul>
    </li>
    <li>
      Actualizar parámetros
      <ul class="second">
        <li (click)="goToURL('service')">Parámetros generales</li>
        <li (click)="goToURL('adminEngagement')">Contratación</li>
        <li (click)="goToURL('categories')">Categorización</li>
        <li (click)="goToURL('kpis')">Categorías/KPIs</li>
        <li (click)="goToURL('report')">Informe</li>
      </ul>
    </li>
    <li (click)="goToURL('audit')">Información de auditoría</li>
    <li (click)="goToURL('logs')">Logs</li>
    <li (click)="goToURL('user-sign-in')">Usuarios registrados</li>
  </ul>
</div>
<div class="admin-container">
  <router-outlet></router-outlet>
</div>
